import {FORGOT_PASSWORD_OK, FORGOT_PASSWORD_FAIL, SET_NEW_PASSWORD_FAIL, SET_NEW_PASSWORD_OK} from './actionTypes';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case FORGOT_PASSWORD_OK:
      return {
        error: '',
        forgotPasswordSuccess: true
      };
    case FORGOT_PASSWORD_FAIL:
      return {
        error: 'We could not find a matching email address.',
        forgotPasswordSuccess: false
      };
    case SET_NEW_PASSWORD_OK:
      return {
        error: '',
        setNewPasswordSuccess: true
      };
    case SET_NEW_PASSWORD_FAIL:
      return {
        error: `Sorry, but we couldn't update your password. Please, try again.`,
        setNewPasswordSuccess: false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/resetPasswordReducer.js